import React from 'react'
import Select from 'react-select'

// material-ui components
import withStyles from 'material-ui/styles/withStyles'

// material-ui
import Chip from 'material-ui/Chip'
import { MenuItem } from 'material-ui/Menu'

// material-ui icons
import ArrowDropDownIcon from 'material-ui-icons/ArrowDropDown'
import CancelIcon from 'material-ui-icons/Cancel'
import ArrowDropUpIcon from 'material-ui-icons/ArrowDropUp'
import ClearIcon from 'material-ui-icons/Clear'

// style
import autocompleteStyle from 'assets/jss/material-dashboard-pro-react/autocompleteStyle.jsx'
import 'react-select/dist/react-select.css'


class Option extends React.Component {
  handleClick = event => {
    this.props.onSelect(this.props.option, event)
  }

  render() {
    // const { children, isFocused, isSelected, onFocus } = this.props
    const { children, isFocused, onFocus } = this.props

    return (
      <MenuItem
        onFocus={onFocus}
        selected={isFocused}
        onClick={this.handleClick}
        component="div"
        // style={{
        //   fontWeight: isSelected ? 500 : 400,
        // }}
      >
        {children}
      </MenuItem>
    )
  }
}

const AutocompleteField = ({ classes, ...other }) => {

  return (
    <Select
      optionComponent={Option}
      noResultsText={<span>Nessun risultato</span>}
      arrowRenderer={arrowProps => {
        return arrowProps.isOpen ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />
      }}
      clearRenderer={() => <ClearIcon />}
      valueComponent={valueProps => {
        const { value, children, onRemove } = valueProps

        const onDelete = event => {
          event.preventDefault()
          event.stopPropagation()
          onRemove(value)
        };

        if (onRemove) {
          return (
            <Chip
              tabIndex={-1}
              label={children}
              className={classes.chip}
              deleteIcon={<CancelIcon onTouchEnd={onDelete} />}
              onDelete={onDelete}
            />
          )
        }

        return <div className="Select-value">{children}</div>;
      }}
      {...other}
    />
  )
}

export default withStyles(autocompleteStyle)(AutocompleteField)


// WEBPACK FOOTER //
// ./src/components/AutocompleteField/AutocompleteField.jsx